import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

// CMS copy is plain text or inline-formatted HTML; anything outside this allowlist is stripped.
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['a', 'span', 'strong', 'b', 'em', 'i', 'u', 'sub', 'sup', 'br'],
  ALLOWED_ATTR: ['class', 'style', 'href', 'target', 'title'],
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Sitecore can double-encode inline tags (&lt;strong&gt;); decode so they parse as real tags.
const decodeTags = (str) => String(str).replace(/&lt;/g, '<').replace(/&gt;/g, '>');

const sanitize = (value) => DOMPurify.sanitize(decodeTags(value), SANITIZE_CONFIG);

/** Renders CMS text or inline HTML as React nodes; null when empty. */
export const renderContent = (value) => (value ? parse(sanitize(value)) : null);

/** Plain text for attributes (alt, aria-label) where markup must not leak through. */
export const toPlainText = (value) =>
  value ? new DOMParser().parseFromString(sanitize(value), 'text/html').body.textContent.trim() : '';
